export const internalEnEN = {
  'howToUse': {
    'referencing': '@:howToUse.test',
    'singularPlural': 'plurale | plurali ($tc(singularPlural,2))',
    'test': 'Test Text',
    'withParameter': "Hallo {name}! $t('lbl_', { name: 'Vue.js'})",
    'zeroOneMany': 'no zeroOneMany | one zeroOneMany | a pack of {n} zeroOneMany  ($tc(zeroOneMany,2))'
  },
  'Comune': 'Town',
  'routes': {
    'ecommerce': process.env.ECOMERCE_URL + '/en',
    'auth': '/',
    '404': '/404',
    'home': '/supplier/',
    'albi_fornitori': '/supplier/albi-fornitori',
    'area_comunicazioni': '/supplier/comunicazioni',
    'area_notifiche': '/supplier/notifiche',
    'bandi_gara': '/supplier/bandi-gara',
    'info_bandi': '/supplier/info-bandi',
    'benchmark': '/supplier/benchmark',
    'tender_result': '/supplier/tender-result',
    'cruscotto': '/supplier/cruscotto',
    'iscrizione': '/supplier/gestione-iscrizione',
    'videoguide_manuali': '/supplier/videoguide_manuali',
    'proced_invito': '/supplier/procedure-invito',
    'repliscrizione': '/supplier/replica-iscrizione',
    'sincronizzazione': '/supplier/sincronizzazione',
    'supporto_tecnico': process.env.BASE_URL + process.env.HELP_DESK_URL,
    'internal_faq': '/supplier/faq',
    'regolamento': '/supplier/regolamento-utilizzo/',
    'user_modifier': '/supplier/user-modifier/',
    'contatti': process.env.ECOMERCE_URL + '/en/contacts/',
    'faq': process.env.ECOMERCE_URL + 'en/faq/ ',
    'network': process.env.ECOMERCE_URL + '/en/the-network/',
    'privacy': process.env.ECOMERCE_URL + '/en/privacy-and-cookies/',
    'servizi': process.env.ECOMERCE_URL + '/en/services-consultancy-support/',
    'subscription': process.env.ECOMERCE_URL + '/en/subscriptions-networkpa/',
    'termini_e_condizioni': process.env.ECOMERCE_URL + '/en/general-terms-and-conditions/',
    'abbonamento_appalti': process.env.ECOMERCE_URL + '/en/services-consultancy-support/',
    'manuali_it_panoramica': process.env.MANUALI_URL + 'it/panoramica-generale.html',
    'manuali_it_gare_inviti': process.env.MANUALI_URL + 'it/gare-e-inviti.html',
    'manuali_it_profilo_sync': process.env.MANUALI_URL + 'it/gestione-profilo-sincronizzazione-qualificazione.html',
    'manuali_it_benchmark': process.env.MANUALI_URL + 'it/analisi-esiti-di-gara-monitoraggio-contratti-competitor.html',
    'manuali_it_notifiche': process.env.MANUALI_URL + 'it/notifiche-comunicazioni.html'
  },
  'tables': {
    'lbl_rows': 'row | rows',
    'lbl_selected': 'selected on | selected on'
  }
}
